import { makeCachedResourceTools } from '@eb/resource-cache-tools';
import { deepKeysToCamel, keysCamelToSnake } from '@eb/transformation-utils';
import isEmpty from 'lodash/isEmpty';
import omitBy from 'lodash/omitBy';
import { formatUrl } from 'url-lib';
import { BASIC_INVENTORY_INFO_EXPANSION } from './constants';

const DEFAULT_ORGANIZATION_EVENTS_PARAMS = {
    showSeriesParent: true,
    orderBy: 'created_desc',
    page: 1,
    pageSize: 6,
    status: 'live,started,ended',
};

export const organizationEventsCache = makeCachedResourceTools(
    ({
        organizationId,
        queryParams = {},
    }: {
        organizationId: string;
        queryParams: object;
    }) =>
        formatUrl(
            `/api/v3/organizations/${organizationId}/events/`,
            keysCamelToSnake({
                ...DEFAULT_ORGANIZATION_EVENTS_PARAMS,
                ...omitBy(queryParams, isEmpty),
                expand: BASIC_INVENTORY_INFO_EXPANSION,
            }),
        ),
    {
        transform: (res: any) => deepKeysToCamel(res),
    },
);
